export default __webpack_public_path__ + "static/media/logo.63898803.svg";